import React from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import PropTypes from "prop-types";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

class ImsAuditChecklistRow extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    splitLines(value) {
        return value ? value.split('\n').map((item, i) => <p key={i}>{item}</p>) : "";
    }

    onChange(event) {
        const fieldName = event.target.id || event.target.name;
        if (this.props.onChangeHandler) {
            this.props.onChangeHandler(fieldName, event.target.value);
        }
    }

    render() {
        const {
            number, header,
            auditFinding, auditFindingName,
            evidenceViewed, evidenceViewedName,
            iso9001, iso14001, iso45001, qualityRequirement,
        } = this.props;
        const iso9001Lines = this.splitLines(iso9001);
        const iso14001Lines = this.splitLines(iso14001);
        const iso45001Lines = this.splitLines(iso45001);
        const qualityRequirementLines = this.splitLines(qualityRequirement);
        const findingValue = auditFinding || "";
        const evidenceValue = evidenceViewed || "";

        return <React.Fragment>
            {header &&
            <TableRow>
                <TableCell align="center" style={{ backgroundColor: 'yellow'}}/>
                <TableCell align="left" colSpan={6} style={{ backgroundColor: 'blue'}}>
                    <Typography component="h7" variant="subtitle1" style={{ padding: "10px", paddingLeft: "20px", color: "white" }}>
                        {header}
                    </Typography>
                </TableCell>
            </TableRow>}
            <TableRow>
                <TableCell align="center" style={{ backgroundColor: 'yellow'}}>
                    {number}
                </TableCell>
                <TableCell align="center" style={{ backgroundColor: `${iso9001 && iso9001 !== "" ? "white" : "lightgrey"}` }}>
                    {iso9001Lines}
                </TableCell>
                <TableCell align="center" style={{ backgroundColor: `${iso14001 && iso14001 !== "" ? "white" : "lightgrey"}` }}>
                    {iso14001Lines}
                </TableCell>
                <TableCell align="center" style={{ backgroundColor: `${iso45001 && iso45001 !== "" ? "white" : "lightgrey"}` }}>
                    {iso45001Lines}
                </TableCell>
                <TableCell align="left" style={{ backgroundColor: `${qualityRequirement && qualityRequirement !== "" ? "white" : "lightgrey"}` }}>
                    {qualityRequirementLines}
                </TableCell>
                <TableCell align="left">
                    <TextField
                        id={evidenceViewedName}
                        name={evidenceViewedName}
                        value={evidenceValue}
                        label={ t('audit.evidenceViewed') }
                        multiline
                        rows={3}
                        onChange={this.onChange}
                        style={{ width: "100%" }}
                    />
                </TableCell>
                <TableCell align="left">
                    <FormControl className={classes.formControl} style={{ width: '100%'}}>
                        <InputLabel id={`${auditFindingName}-labelId`}>{ t('audit.finding') }</InputLabel>
                        <Select
                            labelId={`${auditFindingName}-labelId`}
                            id={auditFindingName}
                            value={findingValue}
                            name={auditFindingName}
                            onChange={this.onChange}
                        >
                            <MenuItem value="Conformance (C)">{ t('imsAuditChecklist.finding.conformance') }</MenuItem>
                            <MenuItem value="Nonconformance (NC)">{ t('imsAuditChecklist.finding.nonconformance') }</MenuItem>
                            <MenuItem value="Observation (OBS)">{ t('imsAuditChecklist.finding.observation') }</MenuItem>
                        </Select>
                    </FormControl>
                </TableCell>
            </TableRow>
        </React.Fragment>;
    }
}

ImsAuditChecklistRow.propTypes = {
    onChangeHandler: PropTypes.func.isRequired,
};

export default withStyles(classes)(ImsAuditChecklistRow);
